export type PxSize = { w: number; h: number };

export const EXPORT_PX: Record<"square" | "framed", PxSize> = {
  square: { w: 1024, h: 1024 },
  // Upright vertical; framing adds headroom; tweakable later
  framed: { w: 1400, h: 1800 },
};


